<template>
  <v-sheet class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4 as-box-title as-bg-color-100" elevation="4" height="150"
    rounded max-width="600" width="100%" mb="6">
    <div>
      <div class="text-h5 font-weight-medium pa-2">
        DIRECCIÓN GENERAL LOGÍSTICA<br>UNIDAD DE MATERIAL BÉLICO
      </div>
      <p class="text-body-2 mb-4">
        Registro clasificado de armas de fuego, municiones y explosivos de uso Militar
      </p>
    </div>
  </v-sheet>

  <v-card>
    <v-tabs
      v-model="tab"
      bg-color=""
      stacked
      align-tabs="center"
    >

      <v-tab value="2">
        <v-img
                  src="@/assets/shorty.png"
                  alt="Imagen"
                  class="as-image-btn"
              ></v-img>
      </v-tab>

      <v-tab value="3">
        <v-img
                  src="@/assets/pngegg.png"
                  alt="Imagen"
                  class="as-image-btn"
              ></v-img>
      </v-tab>

  

      <v-tab value="4">
        <v-img
                  src="@/assets/bayon.png"
                  alt="Imagen"
                  class="as-image-btn"
              ></v-img>
      </v-tab>

    </v-tabs>

    <v-window v-model="tab">
        <v-window-item value="2">
          <ClasArmasPage/>
        </v-window-item>

        <v-window-item value="3">
          <ArmamentoPage/> 
          
        </v-window-item>

        <v-window-item value="4">
          <BayonetaPage/>
        </v-window-item>

      </v-window>

  </v-card>

</template>

<script>
import { defineComponent } from 'vue';
import ClasArmasPage from "@/components/ClasArmasPage.vue"
import BayonetaPage from './BayonetaPage.vue';
import ArmamentoPage from "@/components/ArmamentoPage.vue";
  export default defineComponent({

    data () {
      return {
        tab: null,
      }
    },
    components: {
    ClasArmasPage,
    ArmamentoPage,
    BayonetaPage
},
  });
</script>